import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CrediflowInvoiceStatusQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int'];
}>;


export type CrediflowInvoiceStatusQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', invoices?: { __typename?: 'InvoiceConnection', edges?: Array<{ __typename?: 'InvoiceEdge', node?: { __typename?: 'Invoice', id: string, crediflow?: { __typename?: 'InvoiceCrediflowDeliveryConnection', edges?: Array<{ __typename?: 'InvoiceCrediflowDeliveryEdge', node?: { __typename?: 'InvoiceCrediflowDelivery', id: string, status?: string | null, statusMessage?: string | null, created?: string | null, signedUrl?: string | null } | null } | null> | null } | null } | null } | null> | null } | null } | null };

export const CrediflowInvoiceStatusDocument = gql`
    query crediflowInvoiceStatus($invoiceId: Int!) {
  company {
    invoices(id: $invoiceId) {
      edges {
        node {
          id
          crediflow {
            edges {
              node {
                id
                status
                statusMessage
                created
                signedUrl
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CrediflowInvoiceStatusGQL extends Apollo.Query<CrediflowInvoiceStatusQuery, CrediflowInvoiceStatusQueryVariables> {
    document = CrediflowInvoiceStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }